<template>
    <b-modal ref="modal" size="lg" centered :title="$t('WORKINGGROUPFORM')" @close="close()" no-close-on-backdrop
        no-close-on-esc hide-footer>
        <div class="d-block mt-2">
            <div role="group" class="b-form-group form-group" v-if="formData != null">
                <div class="form-row mb-lg">
                    <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('STARTTIME')">
                            <inputvalidation :formerror="formError" name="startTime">
                                <datetimepicker v-model="formData.startTime" format="DD.MM.YYYY HH:mm:ss"
                                    :first-day-of-week="1" :lang="lang" type="datetime"></datetimepicker>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('ENDTIME')">
                            <inputvalidation :formerror="formError" name="endTime">
                                <datetimepicker v-model="formData.endTime" format="DD.MM.YYYY HH:mm:ss"
                                    :first-day-of-week="1" :lang="lang" type="datetime"></datetimepicker>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div>
                <div class="form-row mb-lg">
                    <div class="col-sm-12">
                        <b-form-fieldset v-bind:label="$t('ROOM')">
                            <inputvalidation :formerror="formError" name="roomId">
                                <lb-vue-select v-model="formData.roomId" :list="rooms.root" :totalCount="rooms.totalCount"
                                    :pagination="roomPagination" display-field="name" value-field="roomId"
                                    :search-placeholder="$t('SEARCH')" :items-placeholder="$t('ROOMS')"
                                    v-on:reload="getRoom">
                                </lb-vue-select>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div>
            </div>

            <div class="text-right">
                <b-btn class="mr-2 button-cancel" @click="close()">{{ $t('CLOSE') }}</b-btn>
                <b-btn class="button-save" @click="submitData(formData)">{{ $t('SAVE') }}</b-btn>
            </div>
        </div>
    </b-modal>
</template>


<script>
import moment from 'moment';
import {
    mapGetters,
}
    from 'vuex';
    import RoomApi from '@/api/room/Room';
    import EventsApi from '@/api/child/Events';

export default
    {
        name: 'EventForm',
        props: ['value'],
        data() {
            const me = this;

            return {
                lang: {
                    days: [me.$t('SUN'), me.$t('MON'), me.$t('TUE'),
                    me.$t('WED'), me.$t('THU'), me.$t('FRI'), me.$t('SAT')],
                    months: [me.$t('JAN'), me.$t('FEB'), me.$t('MAR'), me.$t('APR'),
                    me.$t('MAY'), me.$t('JUN'), me.$t('JUL'), me.$t('AUG'), me.$t('SEP'),
                    me.$t('OCT'), me.$t('NOV'), me.$t('DEC')],
                    pickers: [me.$t('NEXT7DAYS'), me.$t('NEXT30DAYS'), me.$t('PREVIOUS7DAYS'), me.$t('PREVIOUS30DAYS')],
                    placeholder: {
                        date: me.$t('SELECTDATE'),
                        dateRange: me.$t('SELECTDATERANGE'),
                    },
                },
                event: {},
                rooms: {},
                roomPagination:
                {
                    query: '',
                    currentPage: 1,
                    limit: 25,
                    searchTimeout: false,
                },
                formError: {},
                formData: null,
                formEditValue: null,
            };
        },
        methods:
        {
            async submitData(i) {
                const me = this;
                try {
                    const item = { ...i };
                    if (typeof item.eventId !== 'undefined') {
                        item.id = item.eventId;
                        delete (item.eventId);
                    }

                    if (item.roomId != null && parseInt(item.roomId, 10) === 0) {
                        item.roomId = null;
                    }

                    item.startTime = moment(item.startTime).utc().format('YYYY-MM-DD HH:mm:ss');
                    item.endTime = moment(item.endTime).utc().format('YYYY-MM-DD HH:mm:ss');

                    const data = await EventsApi.submitData(item);
                    me.$notify.notice(data);

                    if (data.error) {
                        me.formError = data;
                    }
                    else {
                        me.close();
                    }
                }
                catch (e) {
                    console.log(e);
                    me.$notify.notice(e);
                }
            },
            close() {
                const me = this;
                me.formError = {};
                me.formData = null;
                me.formEditValue = null;
                me.$emit('close');
            },
            async getRoom() {
                const me = this;

                try {
                    const data = await RoomApi.selectRow(me.getParamsRoom);
                    if (data.error && data.error === true) {
                        throw (data);
                    }

                    data.root.unshift({ roomId: 0, name: me.$t('DEFAULTROOM') });
                    me.rooms = data;
                }
                catch (error) {
                    me.$notify.notice(error);
                }
            },
            async getEvent(eventId) {
                const me = this;

                try {
                    const data = await EventsApi.selectRowById({id: eventId});
                    if (data.error && data.error === true) {
                        throw (data);
                    }

                    data.root.startTime = moment.utc(data.root.startTime).local().format('YYYY-MM-DD HH:mm:ss');
                    data.root.endTime = moment.utc(data.root.endTime).local().format('YYYY-MM-DD HH:mm:ss');

                    return data;
                }
                catch (error) {
                    console.log(error);
                    me.$notify.notice(error);
                }
            },
        },
        watch:
        {
            async formEditValue(val) {
                const me = this;
                if (val != null) {

                    await me.getRoom();
                    const response = await me.getEvent(val.eventId);

                    me.formData = {...response.root};
                    me.$refs.modal.show();
                }
                else {
                    me.$refs.modal.hide();
                }
            },
            value(val) {
                const me = this;
                if (val != null) {
                    me.formEditValue = { ...val };
                }
                else {
                    me.formEditValue = null;
                }
            },
        },
        computed:
        {
            ...mapGetters([
                'globals',
            ]),
            getParamsRoom() {
                const me = this;
                const data = {
                    ...me.roomPagination,
                };
                data.start = (data.currentPage - 1) * data.limit;
                return data;
            },
        },
    };
</script>
